import request from "../util/request";

export function taskProjectList(data) {
  return request({
    url: `pr/projects`,
    method: "get",
    data,
  });
}
export function taskRounds(params) {
  return request({
    url: "pr/rounds",
    method: "get",
    params,
  });
}
export function taskSubjects(params) {
  return request({
    url: "pr/subjects",
    method: "get",
    params,
  });
}

export function taskEvent(params) {
  return request({
    url: "pr/tasks",
    method: "get",
    params,
  });
}
export function deleteTaskEvent(id) {
  return request({
    url: `pr/tasks/${id}`,
    method: "delete",
  });
}

// 导出任务的图片
export function exportTaskMedias(params) {
  return request({
    url: "pr/tasks/medias/_export",
    method: "get",
    params,
  });
}

// 导出任务进度
export function exportTasksProgress(params) {
  return request({
    url: "pr/tasks/progress/_export",
    method: "get",
    params,
  });
}

// 导出任务扣分细则
export function exportTaskScores(params) {
  return request({
    url: "pr/tasks/scores/_export",
    method: "get",
    params,
  });
}

export function getSurveyors() {
  return request({
    url: "pr/surveyors",
    method: "get",
  });
}

export function upDateTaskEvents(params) {
  return request({
    url: "pr/tasks/_batch-update",
    method: "put",
    params,
  });
}
export function createProject(data) {
  return request({
    url: "pr/tasks/_batch-create",
    method: "post",
    data,
  });
}
export function getGroupTree(params) {
  return request({
    url: "pr/groups/_tree",
    method: "get",
    params,
  });
}

export function addRounds(data) {
  return request({
    url: "pr/rounds",
    method: "post",
    data,
  });
}
export function editTaskInfo(data, id) {
  return request({
    url: "pr/tasks/" + id,
    method: "put",
    data,
  });
}
export function taskEventPoints(params) {
  return request({
    url: "pr/points",
    method: "get",
    params,
  });
}
export function getTaskInfo({ id }) {
  return request({
    url: "pr/tasks/" + id,
    method: "get",
  });
}
export function getProjectInfo(id) {
  return request({
    url: "pr/projects/" + id,
    method: "get",
  });
}
export function getSubjectPoints(id) {
  return request({
    url: "pr/points/" + id,
    method: "get",
  });
}

export function upDataActions(data) {
  return request({
    url: `pr/points/${data.id}/actions`,
    method: "post",
    data,
  });
}
export function upDataTaskActions(data) {
  return request({
    url: `pr/tasks/${data.id}/actions`,
    method: "post",
    data,
  });
}
export function getTags(params) {
  return request({
    url: `pr/tags`,
    method: "get",
    params,
  });
}
export function createTags(data) {
  return request({
    url: `pr/tags`,
    method: "post",
    data,
  });
}

export function upDataTags(params) {
  return request({
    url: `pr/tags/${params.id}`,
    method: "put",
    params,
  });
}

export function deleteTags({ id }) {
  return request({
    url: `pr/tags/${id}`,
    method: "delete",
  });
}

export function statTags(params) {
  return request({
    url: `pr/tags/_stats`,
    method: "get",
    params,
  });
}

export function upDataSubject(data) {
  return request({
    url: `pr/subjects/${data.id}`,
    method: "put",
    data,
  });
}
export function createSubject(data) {
  return request({
    url: `pr/subjects`,
    method: "post",
    data,
  });
}

export function exportSubjects(params) {
  return request({
    url: `pr/subjects/_export`,
    method: "get",
    params,
  });
}

/** 批量审核 */
export function taskBatchActions(data) {
  return request({
    url: `pr/tasks/batch-actions`,
    method: "post",
    data,
  });
}

/** 单个审核 */
export function taskActions(data) {
  return request({
    url: `pr/tasks/${data.id}/actions`,
    method: "post",
    data,
  });
}

/** 批量更新Tags */
export function subjectsTags(data) {
  return request({
    url: `pr/subjects/tags`,
    method: "post",
    data,
  });
}

/** 删除测评点 */
export function removePointApi({ id }) {
  return request({
    url: `pr/points/${id}`,
    method: "delete",
  });
}

export function removeSubject(data) {
  return request({
    url: `pr/subjects/_destroy-batch`,
    method: "delete",
    data,
  });
}
export function exportPoints(params){
  return request({
    url: `pr/points/_export-appealed-points`,
    method: "get",
    params,
  });
}
export function createPoints(data){
  return request({
    url: `pr/points`,
    method: "post",
    data,
  });
}
export function editPoints(id,data){
  return request({
    url: `pr/points/${id}`,
    method: "put",
    data,
  });
}


